import { usePreference } from '../preferences'

export const useIsFiberOnly = (): { isFiberOnly: boolean; isLoading: boolean } => {
  const { data: isAccountManagementEnabled, isLoading: isAccountManagementLoading } =
    usePreference('enableAccountManagement')
  const { data: isAreaManagementEnabled, isLoading: isAreaManagementLoading } = usePreference('enableAreaManagement')

  return {
    isFiberOnly: Boolean(isAccountManagementEnabled && !isAreaManagementEnabled),
    isLoading: isAccountManagementLoading || isAreaManagementLoading,
  }
}
